/**
 * Famílias de máscara do Hub (categoria `family` em /product-mask-options).
 * Valores alinhados com internal-code-options.ts.
 */
export const MASK_FAMILY = {
  COPO: 'CCP',
  POTE: 'PPT',
  TAMPA_SELAVEL_COPO: 'TSC',
  TAMPA_SELAVEL_POTE: 'TSP',
  BANDEJA_TRAVA: 'BTR',
  BANDEJA_SELAVEL_COM_TAMPA: 'BTS',
  TAMPA_BANDEJA_SELAVEL: 'TBS',
  BANDEJA_SELAVEL_SEM_TAMPA: 'BFB',
  GRATINADEIRA: 'GRT',
  SACO: 'SAC',
  SACOLA: 'SOS',
  CINTA: 'CIN',
} as const

export type MaskFamilyValue = (typeof MASK_FAMILY)[keyof typeof MASK_FAMILY] | string

/** Famílias que têm coluna própria no kanban do Fluxo 2. */
export const SHEET_PRIMARY_FAMILY_VALUES: ReadonlySet<string> = new Set([
  MASK_FAMILY.COPO,
  MASK_FAMILY.POTE,
  MASK_FAMILY.TAMPA_SELAVEL_COPO,
  MASK_FAMILY.TAMPA_SELAVEL_POTE,
])

export type SheetPrimaryFamilyGroup = 'copo' | 'pote' | 'tampa_selavel'

export function normalizeMaskFamilyValue(value?: string | null): string | null {
  if (!value?.trim()) return null
  return value.trim().toUpperCase()
}

export function getSheetPrimaryFamilyGroup(
  familyValue?: string | null
): SheetPrimaryFamilyGroup | null {
  const family = normalizeMaskFamilyValue(familyValue)
  if (!family) return null

  if (family === MASK_FAMILY.COPO) return 'copo'
  if (family === MASK_FAMILY.POTE) return 'pote'
  if (family === MASK_FAMILY.TAMPA_SELAVEL_COPO || family === MASK_FAMILY.TAMPA_SELAVEL_POTE) {
    return 'tampa_selavel'
  }

  return null
}

export function isSheetPrimaryFamily(familyValue?: string | null): boolean {
  const family = normalizeMaskFamilyValue(familyValue)
  return family !== null && SHEET_PRIMARY_FAMILY_VALUES.has(family)
}

/** Fallback legado quando a coluna não traz sheetRule da API. */
export function inferFamilyValueFromColumnName(name: string): string | null {
  const trimmed = name.trim()

  if (/^Copo\b/i.test(trimmed)) return MASK_FAMILY.COPO
  if (/^Pote\b/i.test(trimmed)) return MASK_FAMILY.POTE
  if (/^Tampa selável copo/i.test(trimmed)) return MASK_FAMILY.TAMPA_SELAVEL_COPO
  if (/^Tampa selável pote/i.test(trimmed)) return MASK_FAMILY.TAMPA_SELAVEL_POTE
  if (/^Tampa selável/i.test(trimmed)) return MASK_FAMILY.TAMPA_SELAVEL_COPO

  return null
}
